import { normalizeProducts } from '../../utils/auxFunc'
import { useEffect, useState } from 'react'
import { useAuth } from '../../context/Auth/AuthContext'
import { api } from '../../services/api'
import Home from '../../components/Home'

function HomeContainer() {
  const [products, setProducts] = useState()
  const [banners, setBanners] = useState()
  const { auth, userData } = useAuth()
  const { clientPriceListId } = userData

  const getMostSalesProducts = (id) => {
    api.products
      .listMostSales(id)
      .then((response) => response.json())
      .catch((err) =>
        console.log(
          'Error en la función de getMostSalesProducts: ',
          err.message
        )
      )
      .then((productsApi) => {
        const productsNormalized = normalizeProducts(productsApi)
        setProducts(productsNormalized)
      })
      .catch((err) => console.log(err.message))
  }

  const getBanners = () => {
    api.banners
      .getBanners()
      .then((response) => response.json())
      .catch((err) => console.log(err.message))
      .then((bannersApi) => setBanners(bannersApi))
      .catch((err) => console.log(err.message))
  }

  useEffect(() => {
    getMostSalesProducts(clientPriceListId)
    getBanners()
  }, [clientPriceListId])

  return <Home auth={auth} products={products} banners={banners} />
}

export default HomeContainer
